import React from 'react';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';
import { Form, Input, Row, Col, Button, Upload, Icon, message, Radio, Modal } from 'antd';
import util from '../../util';
import FormContent from './FormInfo'; 

const { getAccessToken, getRandom } = util;
const RadioGroup = Radio.Group;

@inject('ecodeStore')
@observer
class App extends React.Component {
  static defaultProps = {
    prefixCls: 'ecode-title',
    secondaryModule: 'workflowChart',
    buttonClassName: '',
    icon: '',
  }
  constructor(props) {
    super(props);
    this.state = { 
      renderFrom: false,
      visible: props.visible || false,
    }
  }
  componentDidMount() {
    const { ecodeStore: { uploadFileList, setMobxState } } = this.props;
    const access_token = getAccessToken();
    uploadFileList.length < 1 && setMobxState({uploadFileSubmit: true, access_token});
    const { visible } = this.props;
    const { visible: _visible } = this.state;
    visible !== undefined && visible !== _visible && this.setState({visible});
  }
  componentWillUnmount() {
    this.initUploadFile();
    this.init();
  }
  componentWillReceiveProps(nextProps) {
    const { visible } = nextProps;
    const { visible: _visible } = this.state;
    visible !== undefined && visible !== _visible && this.setState({visible});
  }

  /**
   * 退出上传弹出框事件
   */
  onCancel = () => {
    const { onCancel } = this.props;
    this.setState({
      visible: false
    });
    this.initUploadFile();
    this.init();
    typeof onCancel === 'function' && onCancel();
  }

  /**
   * 初始化弹出框设置
   */
  init = () => {
    this.setState({
      renderFrom: false,
    })
  }

  /**
   * 初始化文件列表
   */
  initUploadFile = () => {
    const { form, ecodeStore: { setMobxState } } = this.props;
    setMobxState({
      uploadFileList: [],
      uploadFileSubmit: true,
      fieldList: [],
    });
    form.resetFields();
  }

  /**
   * 上传文件勾子
   * @param {Object} file 文件信息
   */
  beforeUpload = file => {
    return false;
  }

  /**
   * 上传标题空校验
   */
  checkLen = (rule, value, callback) => {
    if (!value || value.trim() === "") {
      callback([new Error(' 案例标题不能为空')]);
    } else {
      callback();
    }
  }

  /**
   * 渲染内容上传文件弹出框内容
   * 
   */
  renderContent = () => {
    const { prefixCls, form, ecodeStore: { uploadFileList, setMobxState } } = this.props;
    const { getFieldDecorator } = form;
    return (
      <div className={`${prefixCls}`}>
        <Form>
          <Row className={`${prefixCls}-form`}>
            <Col span={6} className={`${prefixCls}-form-label`}><span>案例标题：</span></Col>
            <Col span={18} className={`${prefixCls}-form-wrapper`}>
              <Form.Item>
                {
                  getFieldDecorator('title', {
                    rules: [{ validator: this.checkLen }],
                  })(<Input placeholder="请输入案例标题"/>)
                }
              </Form.Item>
            </Col>
          </Row>
          <Row className={`${prefixCls}-form`}>
            <Col span={6} className={`${prefixCls}-form-label`}><span>上传：</span></Col>
            <Col span={18} className={`${prefixCls}-form-wrapper`}>
              <Form.Item>
                <Upload
                  listType='text'
                  accept=".zip, .xml"
                  // action={`https://www.mocky.io/v2/5cc8019d300000980a055e76`}
                  // action={`${window.server}/v5/ecode/outLineDemo`}
                  method="post"
                  fileList={uploadFileList}
                  beforeUpload={this.beforeUpload}
                  onChange={(info) => {
                    let fileList = [...info.fileList];
                    fileList = fileList.slice(-1);
                    setMobxState({ 
                      uploadFileList: fileList,
                      uploadFileSubmit: info.fileList.length === 0
                    });
                    if (info.file.status === 'done') {
                      setMobxState({ uploadFileSubmit: false });
                    }
                    if (info.file.status === 'error') {
                      setMobxState({ uploadFileList: [], uploadFileSubmit: true });
                      message.config({
                        top: 24,
                      });
                      message.error('上传错误');
                    }
                  }}
                  onPreview={() => {}}
                >
                  <Button>
                    <Icon type="upload" />上传附件
                  </Button>
                </Upload>
              </Form.Item>
              <a className="upload-instructions" onClick={() => window.open("https://e-cloudstore.com/doc.html?appId=d0bdb590e0ed42e58ec9b65a328e8d45")}>上传说明</a>
            </Col>
          </Row>
        </Form>
      </div>
    )
  }

  /**
   * 数据提交验证
   */
  onSubmit = () => {
    const { form, ecodeStore: { onUpload, setMobxState, getFieldList, getDemoInfo } } = this.props;
    form.validateFields((err, values) => {
      if (!err) {
        onUpload({title: values.title.trim()}).then(data => {
          this.initUploadFile();
          this.setState({
            renderFrom: true,
            visible: false,
          });
          setMobxState({ id: data.demoId, secondaryModule: data.demoType, success: false, documentLoading: true });
          getFieldList({
            secondaryModule: data.demoType,
          }).then((result) => {
            if (result.status) {
              const tempData = result.list;
              setMobxState({ disabledSubmit: tempData.find((da) => da.conditionType === 'upload') });
            } else {
              setMobxState({ disabledSubmit: true });
            }
            getDemoInfo({
              id: data.demoId,
            }).then(() => {
              // 初始化表单
              this.formContent && this.formContent.wrappedInstance && this.formContent.wrappedInstance.initForm && this.formContent.wrappedInstance.initForm();
              setMobxState({ documentLoading: false });
            });
          });
        });
      }
    });
  }

  /**
   * 按钮点击事件
   */
  onClick = () => {
    const { onClick } = this.props;
    this.setState({visible: true});
    typeof onClick === 'function' && onClick();
  }

  render() {
    const { renderFrom, visible } = this.state;
    const { demoType, icon, buttonClassName, className, ecodeStore: { isEdit, uploadFileLoading, uploadFileSubmit }, title } = this.props;
    return (
      <div
        className={className}
      >
        <Button
          onClick={this.onClick}
          className={`${buttonClassName}`}
          icon={icon}
        >
          {title}
        </Button>
        <FormContent
          secondaryModule={demoType}
          visible={renderFrom}
          wrappedComponentRef={ref => this.formContent = ref}
          title={title}
          onCancel={() => {
            this.setState({renderFrom: false});
            this.onCancel();
          }}
        />
        <Modal
          visible={visible}
          onCancel={this.onCancel}
          width={500}
          bodyStyle={{
            height: 200,
            overflow: 'auto',
            padding: '40px 24px 0',
          }}
          maskClosable={false}
          title={title || "表单上传"}
          footer={[
            <Button type="primary" key="submit" disabled={!renderFrom && uploadFileSubmit} loading={uploadFileLoading} onClick={
              this.onSubmit
            }>提交</Button>,
            <Button key="cancel" onClick={this.onCancel}>取消</Button>,
          ]}
        >
          { 
            this.renderContent()
          }
        </Modal>
      </div>
    )
  }
}

App = Form.create()(App);
export default App;


// WEBPACK FOOTER //
// ./src/components/ecodeLocal/index.js